import * as React from 'react';

import * as styles from './GalleryInfoMobile.css';

interface IGalleryInfoMobileProps {
  factoids: string;
  name: string;
}

export const GalleryInfoMobile: React.FC<IGalleryInfoMobileProps> = ({ factoids, name }) => {
  return (
    <div>
      <div className={styles['name']}>{name}</div>
      <div className={styles['factoids']}>{factoids}</div>
    </div>
  );
};
